function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

export var statusActions;

(function (statusActions) {
  statusActions["ok"] = "ok";
  statusActions["error"] = "error";
})(statusActions || (statusActions = {}));

export var listUserSubdata = ["beneficiario", "contratante", "asegurado"];
export var listPolizaSubData = ["beneficiario", "contratante", "asegurado", "payment_information", "broker_information", "document_actions", "assist_card_actions", "poliza_endorsement"];
export var createPoliza = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(poliza, token) {
    var formData, response, contentType, polizaResponse, textResponse;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            formData = buildPolizaFormData(poliza);
            _context.next = 4;
            return fetch("/api/v1/polizas", {
              method: "POST",
              headers: {
                Accept: "application/json",
                "X-CSRF-Token": token
              },
              body: formData
            });

          case 4:
            response = _context.sent;
            // Check if response is JSON before parsing
            contentType = response.headers.get("content-type");

            if (!(contentType && contentType.includes("application/json"))) {
              _context.next = 12;
              break;
            }

            _context.next = 9;
            return response.json();

          case 9:
            polizaResponse = _context.sent;
            _context.next = 17;
            break;

          case 12:
            _context.next = 14;
            return response.text();

          case 14:
            textResponse = _context.sent;
            console.error("Server returned non-JSON response:", textResponse.substring(0, 500));
            return _context.abrupt("return", {
              status: statusActions.error,
              payload: {
                message: "Error del servidor (".concat(response.status, "): ").concat(response.statusText, ". Por favor, revisa los logs del servidor.")
              }
            });

          case 17:
            if (response.ok) {
              _context.next = 19;
              break;
            }

            return _context.abrupt("return", {
              status: statusActions.error,
              payload: polizaResponse
            });

          case 19:
            return _context.abrupt("return", {
              status: statusActions.ok,
              payload: polizaResponse
            });

          case 22:
            _context.prev = 22;
            _context.t0 = _context["catch"](0);
            console.error(_context.t0);
            return _context.abrupt("return", {
              status: statusActions.error,
              payload: {
                message: (_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message) || "Error al crear la póliza"
              }
            });

          case 26:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 22]]);
  }));

  return function createPoliza(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var duplicatePoliza = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(polizaId, token) {
    var response, data;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return fetch("/api/v1/polizas/".concat(polizaId, "/duplicate"), {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "X-CSRF-Token": token
              }
            });

          case 3:
            response = _context2.sent;
            _context2.next = 6;
            return response.json();

          case 6:
            data = _context2.sent;

            if (response.ok) {
              _context2.next = 9;
              break;
            }

            return _context2.abrupt("return", {
              status: statusActions.error,
              payload: (data === null || data === void 0 ? void 0 : data.message) || (data === null || data === void 0 ? void 0 : data.error) || "Error al copiar la propuesta"
            });

          case 9:
            return _context2.abrupt("return", {
              status: statusActions.ok,
              payload: data
            });

          case 12:
            _context2.prev = 12;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", {
              status: statusActions.error,
              payload: {
                message: (_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.message) || "Error al copiar la propuesta"
              }
            });

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 12]]);
  }));

  return function duplicatePoliza(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();
export var updatePoliza = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(poliza, token) {
    var formData, response, contentType, polizaResponse, textResponse;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            formData = buildPolizaFormData(poliza);
            _context3.next = 4;
            return fetch("/api/v1/polizas/".concat(poliza.id), {
              method: "PATCH",
              headers: {
                Accept: "application/json",
                "X-CSRF-Token": token
              },
              body: formData
            });

          case 4:
            response = _context3.sent;
            // Check if response is JSON before parsing
            contentType = response.headers.get("content-type");

            if (!(contentType && contentType.includes("application/json"))) {
              _context3.next = 12;
              break;
            }

            _context3.next = 9;
            return response.json();

          case 9:
            polizaResponse = _context3.sent;
            _context3.next = 17;
            break;

          case 12:
            _context3.next = 14;
            return response.text();

          case 14:
            textResponse = _context3.sent;
            console.error("Server returned non-JSON response:", textResponse.substring(0, 500));
            return _context3.abrupt("return", {
              status: statusActions.error,
              payload: {
                message: "Error del servidor (".concat(response.status, "): ").concat(response.statusText, ". Por favor, revisa los logs del servidor.")
              }
            });

          case 17:
            if (response.ok) {
              _context3.next = 19;
              break;
            }

            return _context3.abrupt("return", {
              status: statusActions.error,
              payload: polizaResponse
            });

          case 19:
            return _context3.abrupt("return", {
              status: statusActions.ok,
              payload: polizaResponse
            });

          case 22:
            _context3.prev = 22;
            _context3.t0 = _context3["catch"](0);
            console.error(_context3.t0);
            return _context3.abrupt("return", {
              status: statusActions.error,
              payload: {
                message: (_context3.t0 === null || _context3.t0 === void 0 ? void 0 : _context3.t0.message) || "Error al actualizar la póliza"
              }
            });

          case 26:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 22]]);
  }));

  return function updatePoliza(_x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}();
export var createPolizaEndorsement = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(poliza, token) {
    var formData, response, polizaResponse;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            formData = buildPolizaFormData(poliza);
            formData.append("poliza_endorsement[poliza_id]", poliza.id);
            _context4.next = 5;
            return fetch("/api/v1/poliza_endorsements", {
              method: "POST",
              headers: {
                Accept: "application/json",
                "X-CSRF-Token": token
              },
              body: formData
            });

          case 5:
            response = _context4.sent;
            _context4.next = 8;
            return response.json();

          case 8:
            polizaResponse = _context4.sent;
            return _context4.abrupt("return", {
              status: statusActions.ok,
              payload: polizaResponse
            });

          case 12:
            _context4.prev = 12;
            _context4.t0 = _context4["catch"](0);
            console.error(_context4.t0);
            return _context4.abrupt("return", {
              status: statusActions.error
            });

          case 16:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 12]]);
  }));

  return function createPolizaEndorsement(_x7, _x8) {
    return _ref4.apply(this, arguments);
  };
}();
export var sendDispatchEmail = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(polizaId, groupCheckbox, token) {
    var response, responseJson;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return fetch("/api/v1/polizas/".concat(polizaId, "/send_email"), {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "X-CSRF-Token": token
              },
              body: JSON.stringify({
                group_checkbox: groupCheckbox
              })
            });

          case 3:
            response = _context5.sent;
            _context5.next = 6;
            return response.json();

          case 6:
            responseJson = _context5.sent;
            return _context5.abrupt("return", {
              status: statusActions.ok,
              payload: responseJson
            });

          case 10:
            _context5.prev = 10;
            _context5.t0 = _context5["catch"](0);
            console.error(_context5.t0);
            return _context5.abrupt("return", {
              status: statusActions.error
            });

          case 14:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 10]]);
  }));

  return function sendDispatchEmail(_x9, _x10, _x11) {
    return _ref5.apply(this, arguments);
  };
}();
export var sendExpirationEmail = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(polizaId, token, additionalMessage) {
    var response, responseJson;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return fetch("/api/v1/polizas/".concat(polizaId, "/send_expiration_email"), {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "X-CSRF-Token": token
              },
              body: JSON.stringify({
                additional_message: additionalMessage || ""
              })
            });

          case 3:
            response = _context6.sent;
            _context6.next = 6;
            return response.json();

          case 6:
            responseJson = _context6.sent;
            return _context6.abrupt("return", {
              status: statusActions.ok,
              payload: responseJson
            });

          case 10:
            _context6.prev = 10;
            _context6.t0 = _context6["catch"](0);
            console.error(_context6.t0);
            return _context6.abrupt("return", {
              sstatus: statusActions.error
            });

          case 14:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 10]]);
  }));

  return function sendExpirationEmail(_x12, _x13, _x14) {
    return _ref6.apply(this, arguments);
  };
}();
export var sendChargeEmail = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(token, poliza_payment_id) {
    var response, responseJson;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            _context7.next = 3;
            return fetch("/api/v1/poliza_payment/".concat(poliza_payment_id, "/send_charge_email"), {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "X-CSRF-Token": token
              }
            });

          case 3:
            response = _context7.sent;
            _context7.next = 6;
            return response.json();

          case 6:
            responseJson = _context7.sent;
            return _context7.abrupt("return", {
              status: statusActions.ok,
              payload: responseJson
            });

          case 10:
            _context7.prev = 10;
            _context7.t0 = _context7["catch"](0);
            console.error(_context7.t0);
            return _context7.abrupt("return", {
              status: statusActions.error
            });

          case 14:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[0, 10]]);
  }));

  return function sendChargeEmail(_x15, _x16) {
    return _ref7.apply(this, arguments);
  };
}();

var buildPolizaFormData = function buildPolizaFormData(poliza) {
  var formData = new FormData(); // buildFormatDataFromJson(formData, poliza, "poliza");

  for (var key in poliza) {
    if (listPolizaSubData.includes(key)) {
      buildPolizaSubData(formData, poliza[key], key);
    } else if (key === "beneficiarios" && Array.isArray(poliza.beneficiarios) && poliza.beneficiarios.length > 0) {
      formData.append("poliza[beneficiarios]", JSON.stringify(poliza.beneficiarios));
    } else if (key === "item_asegurados") {
      buildItemAseguradoFormData(formData, poliza.item_asegurados);
    } else if (key === "additional_files") {
      buildAdditionalFilesFormData(formData, poliza.additional_files);
    } else if (key === "additional_files_actions") {
      buildAdditionalFilsActionsFormData(formData, poliza.additional_files_actions);
    } else if (key !== "commission" && poliza[key] !== undefined && poliza[key] !== null) {
      var value = poliza[key];
      formData.append("poliza[".concat(key, "]"), value);
    }
  }

  if (poliza.commission != null) {
    var executiveId = poliza.commission.insurance_broker_executive_id;
    formData.append("poliza[insurance_broker_executive_id]", executiveId != null ? String(executiveId) : "");
  }

  return formData;
};

var buildPolizaSubData = function buildPolizaSubData(formData, subForm, key) {
  for (var subKey in subForm) {
    if (["emails", "addresses"].includes(subKey)) {
      buildSubFormData(formData, subForm, key, subKey);
    } else if (subForm[subKey] !== undefined && subForm[subKey] !== null) formData.append("poliza[".concat(key, "][").concat(subKey, "]"), subForm[subKey]);
  }

  return formData;
};

var buildItemAseguradoFormData = function buildItemAseguradoFormData(formData, itemAsegurado) {
  itemAsegurado.forEach(function (item, index) {
    Object.entries(item).forEach(function (_ref8) {
      var _ref9 = _slicedToArray(_ref8, 2),
          key = _ref9[0],
          value = _ref9[1];

      if (value !== null && value !== undefined) {
        formData.append("poliza[item_asegurados][".concat(index, "][").concat(key, "]"), value);
      }
    });
  });
};

var buildSubFormData = function buildSubFormData(formData, subForm, key, sub_key) {
  for (var i = 0; i < subForm[sub_key].length; i++) {
    for (var email_sub_key in subForm[sub_key][i]) {
      if (subForm[sub_key][i][email_sub_key] !== undefined && subForm[sub_key][i][email_sub_key] !== null) {
        formData.append("poliza[".concat(key, "][").concat(sub_key, "][][").concat(email_sub_key, "]"), subForm[sub_key][i][email_sub_key]);
      }
    }
  }
};

var buildAdditionalFilesFormData = function buildAdditionalFilesFormData(formData, fileList) {
  for (var fileKey in fileList) {
    if (fileList[fileKey]) formData.append("poliza[additional_files][]", fileList[fileKey]);
  }

  return formData;
};

var buildAdditionalFilsActionsFormData = function buildAdditionalFilsActionsFormData(formData, filesActions) {
  filesActions.forEach(function (fileAction) {
    for (var key in fileAction) {
      formData.append("poliza[additional_files_actions][][".concat(key, "]"), fileAction[key]);
    }
  });
};